import { z } from 'zod';

import { analyticsStatCategorySchema } from '../analyticsStatCategory';

const catalogKindSchema = z.enum(['grouping', 'stat', 'display']);

export const staffGlobalStatCatalogRowSchema = z.object({
  catalogId: z.string(),
  label: z.string(),
  tooltip: z.string().nullable(),
  kind: catalogKindSchema,
  ref: z.string(),
  statKeys: z.array(z.string()),
  tags: z.array(z.string()),
  idColumnAlias: z.string().optional(),
});

export type StaffGlobalStatCatalogRow = z.infer<typeof staffGlobalStatCatalogRowSchema>;

export const staffGlobalStatDiscoveryEntrySchema = z.object({
  statKey: z.string(),
  statName: z.string(),
  category: analyticsStatCategorySchema,
  description: z.string().optional(),
});

export type StaffGlobalStatDiscoveryEntry = z.infer<typeof staffGlobalStatDiscoveryEntrySchema>;

export const staffGlobalStatColumnCatalogResponseSchema = z.object({
  catalog: z.array(staffGlobalStatCatalogRowSchema),
});

export type StaffGlobalStatColumnCatalogResponse = z.infer<
  typeof staffGlobalStatColumnCatalogResponseSchema
>;

export type StaffGlobalCatalogScope = 'client' | 'partner' | undefined;
